// File: frontend/src/pages/Plato/components/CapabilityMatrix/CapabilityMatrix.js

import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { X, Check, Minus } from 'lucide-react';
import styles from './CapabilityMatrix.module.css';

const CapabilityMatrix = ({ capabilities, onClose }) => {
  const { t } = useLanguage();
  
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <h3>{t('plato.capability_matrix.title')}</h3>
          <button className={styles.closeButton} onClick={onClose}>
            <X size={18} />
          </button>
        </div>
        <div className={styles.content}>
          <div className={styles.matrixContainer}>
            <table className={styles.matrixTable}>
              <thead>
                <tr>
                  <th className={styles.categoryHeader}>{t('plato.capability_matrix.category')}</th>
                  <th className={styles.capabilityHeader}>{t('plato.capability_matrix.capability')}</th>
                  {capabilities.versions.map(version => (
                    <th key={version} className={styles.versionHeader}>{version}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {capabilities.categories.map((category, categoryIndex) => (
                  <React.Fragment key={`category-${categoryIndex}`}>
                    {category.capabilities.map((capability, capabilityIndex) => (
                      <tr key={`capability-${categoryIndex}-${capabilityIndex}`}>
                        {capabilityIndex === 0 && (
                          <td 
                            className={styles.categoryCell} 
                            rowSpan={category.capabilities.length}
                          >
                            <div className={styles.categoryName}>{category.name}</div>
                            <div className={styles.categoryDescription}>{category.description}</div>
                          </td>
                        )}
                        <td className={styles.capabilityCell}>{capability.name}</td>
                        {capabilities.versions.map(version => (
                          <td 
                            key={`status-${categoryIndex}-${capabilityIndex}-${version}`}
                            className={styles.statusCell}
                          >
                            {capability.versions[version] ? (
                              <span className={styles.statusAvailable}><Check size={16} /></span>
                            ) : (
                              <span className={styles.statusUnavailable}><Minus size={16} /></span>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
          
          <div className={styles.legend}>
            <div className={styles.legendItem}>
              <span className={styles.statusAvailable}><Check size={16} /></span>
              <span>{t('plato.capability_matrix.available')}</span>
            </div>
            <div className={styles.legendItem}>
              <span className={styles.statusUnavailable}><Minus size={16} /></span>
              <span>{t('plato.capability_matrix.planned')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CapabilityMatrix;